// Single source of truth for the /runs/<id> palette. Every viz on the
// page (outcome-bar, progress-chart, run-sankey) imports from here so a
// given logical bucket renders the same color everywhere.

export const RUN_COLORS = {
  pushed:      "hsl(142 70% 45%)",   // success green — new lead in Close
  duplicate:   "hsl(142 30% 55%)",   // muted green — extracted, lead already in Close
  tagged:      "hsl(220 9% 50%)",    // medium grey — matched a check, no lead
  noMatch:     "hsl(220 14% 72%)",   // light grey — no check fired
  unreachable: "hsl(0 30% 55%)",     // muted red — target down, expected, not actionable
  error:       "hsl(0 73% 60%)",     // danger red — internal extract / worker failure
  pending:     "hsl(220 14% 65%)",   // bluish grey — claimed, in-flight
  preFiltered: "hsl(217 33% 25%)",   // dark grey — dropped before claim
  notYetRead:  "hsl(217 33% 14%)",   // very dark — upstream backlog
  input:       "hsl(217 91% 65%)",   // accent blue — sankey source nodes
  evaluated:   "hsl(217 91% 60%)",   // accent blue — sankey hub
  pushedLine:  "hsl(142 70% 65%)",   // brighter pushed — line overlay on chart
} as const;

export const CHECK_PALETTE = [
  "hsl(280 65% 65%)",
  "hsl(180 65% 55%)",
  "hsl(330 80% 65%)",
  "hsl(46 95% 60%)",
  "hsl(200 80% 60%)",
  "hsl(20 80% 60%)",
];
